import * as DateUtilities from "../../../utilities/dateUtilities";
import { constants } from "../../../constants";

export const getDuration = (date, soCode=null) => {
  const FeedlocalDate = DateUtilities.convertStringToLocalTime(date);
  const formatdate = DateUtilities.getFeedDateFormat(FeedlocalDate, soCode);
  return formatdate;
};

export const getStationContents = (item, appBaseURL) => {
  const content = {};
  switch (item?.feedName) {
    case "SRS_PROGRAMMEGOALS":
      content.mediaStyle = "SRS";
      content.text = item?.mediaTitle;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = appBaseURL?.concat(item?.feedIconPath);
      break;
    case "SRS_PROGRAMCHANGE":
      content.mediaStyle = "SRS";
      content.text = item?.mediaTitle;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = appBaseURL?.concat(item?.feedIconPath);
      break;
    case "SRS_CHILDPARTICIPATION":
      content.mediaStyle = "SRS";
      content.text = item?.mediaTitle;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = appBaseURL?.concat(item?.feedIconPath);
      break;
    case "SRS_CHILDHEALTH":
      content.mediaStyle = "SRS";
      content.text = item?.mediaTitle;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = appBaseURL?.concat(item?.feedIconPath);
      break;
    case "SRS_CHILDEDUCATION":
      content.mediaStyle = "SRS";
      content.text = item?.mediaTitle;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = appBaseURL?.concat(item?.feedIconPath);
      break;
    case "SRS_MAILACTIONROUTE":
      content.mediaStyle = "SRS";
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = appBaseURL?.concat(item?.feedIconPath);  
      if(((constants?.letterTrackingLevelsNonSRS?.includes(item?.contentType)))){
        content.mediaStyle = "PDF";
        content.mediaIcon = item?.mediaThumbURL;    
      }
      break;
    case "SRS_CHANGESTORY":
      content.mediaStyle = item?.mediaType === "VIDEO" ? "Video" : "Image";
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = item?.mediaThumbURL;
      break;
    case "DC_APML":
      content.mediaStyle = "PDF";
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = item?.mediaThumbURL;
      break;
    case "DC_APR":
      content.mediaStyle = "PDF";
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = item?.mediaThumbURL;
      break;
    case "DC_GREETINGS":
      content.mediaStyle = "PDF";
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = item?.mediaThumbURL;
      break;
    case "DC_LETTER":
      content.mediaStyle = "PDF";
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = item?.mediaThumbURL;
      break;
    case "DC_THANKYOU":
      content.mediaStyle = "PDF";
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = item?.mediaThumbURL;
      break;
    case "DC_CEW":
      content.mediaStyle = "PDF";
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = item?.mediaThumbURL;
      break;
    case "CHILD":
      content.mediaStyle = item?.mediaType === "VIDEO" ? "Video" : "Image";
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = item?.mediaThumbURL;
      break;
    case "COMMUNITY":
      content.mediaStyle = item?.mediaType === "VIDEO" ? "Video" : "Image";
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = item?.mediaThumbURL;
      break;
    case "CLB_SPNSHIP_ANNV":
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      item.sponsorshipAniveraryVisible = true;
      content.mediaIcon = item?.mediaThumbURL;
      break;
    case "BIRTHDAY": 
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = item?.mediaThumbURL;
      content.birthdayCardVisible = item?.birthdayCardVisible;
      break; 
    case "SRS_ANNUALPLANS":
      content.renderUI = "PLANS";
      content.planIndex = item?.planIndex;
      content.text = item?.title;
      content.mediaBody = item?.mediaBody;
      content.mediaIcon = item?.mediaThumbURL;
      content.imageOnly = item?.imageOnly;
      break;  
    default:
      content.mediaStyle = item?.mediaType === "VIDEO" ? "Video" : "Image";
      content.text = item?.title;
      content.mediaBody = item?.mediaBody ? item?.mediaBody : item?.description;
      content.mediaIcon = item?.mediaThumbURL;
      break;
  }
  return content;
};
